export class DpomApproveRequest {
    purchaseOrderNumber: string;
    poLineItemNumber: number;
    scheduleLineItemNumber: string;
}